import React from 'react';
import { Trans } from '@lingui/macro';

function FAQ() {
  return (
    <section className="section bg-light" id="faq">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 mb-4 pb-2">
            <div className="section-title text-center">
              <h4 className="title mb-4"><Trans>FREQUENTLY ASKED QUESTIONS</Trans></h4>
              <p className="para-desc mx-auto mb-0"><Trans>Find answers to common questions about Amaré Music Festival.</Trans></p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="accordion" id="faqAccordion">

              {/* Question 1 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                    <Trans>When and where is Amaré Music Festival happening?</Trans>
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>Amaré Music Festival will take place on</Trans> <strong><Trans>August 22, 2026</Trans></strong>, <Trans>in a field near</Trans> <strong>1200 Chemin de la Belgique, Manseau, Quebec, Canada</strong>. <Trans>Gates will open at 3 PM, and the site will close at 11 PM.</Trans>
                  </div>
                </div>
              </div>

              {/* Question 2 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    <Trans>How can I buy tickets?</Trans>
                  </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>Tickets can be purchased online through our official website. Visit the</Trans> <a href='#tickets' className='text-primary'><Trans>Tickets</Trans></a> <Trans>section for more details.</Trans>
                  </div>
                </div>
              </div>

              {/* Question 3 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThree">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <Trans>What is included in the Ruby Prestige Package?</Trans>
                  </button>
                </h2>
                <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>The Ruby Prestige Package is designed for 4 people and includes:</Trans>
                    <ul>
                      <li><Trans>4x Access to Amaré Music Festival</Trans></li>
                      <li><Trans>4x Exclusive access to the VIP lounge area (premium covered area)</Trans></li>
                      <li><Trans>1x Reserved VIP table</Trans></li>
                      <li><Trans>Premium viewing areas near the stage</Trans></li>
                      <li><Trans>Private access to the bar</Trans></li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Question 4 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFour">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    <Trans>What is included in the Sapphire Luxury Pass?</Trans>
                  </button>
                </h2>
                <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>The Sapphire Luxury Pass includes:</Trans>
                    <ul>
                      <li><Trans>1x Access to Amaré Music Festival</Trans></li>
                      <li><Trans>1x Exclusive access to the VIP lounge area (premium covered area)</Trans></li>
                      <li><Trans>Premium viewing areas near the stage</Trans></li>
                      <li><Trans>Private access to the bar</Trans></li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Question 5 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFive">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    <Trans>What is the minimum age to attend Amaré Music Festival?</Trans>
                  </button>
                </h2>
                <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>Amaré Music Festival is an 18+ event. All attendees must be at least 18 years old, and a valid government-issued ID will be required for entry.</Trans>
                  </div>
                </div>
              </div>

              {/* Question 6 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSix">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    <Trans>Can I bring my own food and drinks?</Trans>
                  </button>
                </h2>
                <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>Outside food and drinks are not permitted on the festival grounds. However, a variety of food options and a bar will be available on-site for your convenience.</Trans>
                  </div>
                </div>
              </div>

              {/* Question 7 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSeven">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                    <Trans>Can I bring a water bottle or CamelBak to the festival?</Trans>
                  </button>
                </h2>
                <div id="collapseSeven" className="accordion-collapse collapse" aria-labelledby="headingSeven" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>Yes, you could bring a water bottle or CamelBak, but it must be empty upon entry.</Trans>
                    <ul>
                      <li><Trans>Plastic water bottles: Must be empty on entry • Max 32 oz (1L)</Trans></li>
                      <li><Trans>Hydration packs (CamelBaks): Must be empty on entry • Max 70 oz (2L)</Trans></li>
                    </ul>
                    <p><Trans>Free water refill station will be available on-site.</Trans></p>
                    <p class="notice"><Trans>Glass, metal containers, and full/opened bottles cannot be brought in.</Trans></p>
                  </div>
                </div>
              </div>

              {/* Question 8 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingEight">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEight" aria-expanded="false" aria-controls="collapseEight">
                    <Trans>Is camping available at the festival?</Trans>
                  </button>
                </h2>
                <div id="collapseEight" className="accordion-collapse collapse" aria-labelledby="headingEight" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>Yes, camping is available for all attendees near the parking area, and it’s completely free of charge!</Trans>
                    <ul>
                      <li><Trans>Feel free to bring a tent, but please note the camping area is vehicle-free.</Trans></li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Question 9 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingNine">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNine" aria-expanded="false" aria-controls="collapseNine">
                    <Trans>Can I vape or smoke at the festival?</Trans>
                  </button>
                </h2>
                <div id="collapseNine" className="accordion-collapse collapse" aria-labelledby="headingNine" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>Smoking is not allowed on the festival grounds, but vaping is tolerated. We ask that you keep this in mind to ensure the comfort and enjoyment of all attendees. Thanks for helping keep the atmosphere fresh and enjoyable for everyone!</Trans>
                  </div>
                </div>
              </div>

              {/* Question 10 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTen">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTen" aria-expanded="false" aria-controls="collapseTen">
                    <Trans>Can families with children attend the festival?</Trans>
                  </button>
                </h2>
                <div id="collapseTen" className="accordion-collapse collapse" aria-labelledby="headingTen" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>Amaré Music Festival is an 18+ event and is not intended for children. All attendees must be at least 18 years old, and a valid government-issued ID will be required for entry. This policy ensures a safe and enjoyable experience for all festival-goers.</Trans>
                  </div>
                </div>
              </div>

              {/* Question 11 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingEleven">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEleven" aria-expanded="false" aria-controls="collapseEleven">
                    <Trans>Can I volunteer at the festival?</Trans>
                  </button>
                </h2>
                <div id="collapseEleven" className="accordion-collapse collapse" aria-labelledby="headingEleven" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>Yes! We’re always looking for enthusiastic volunteers. Send us a message to apply at</Trans> <a href="mailto:volunteer@amarefestival.com" className="text-primary">volunteer@amarefestival.com</a>, <Trans>and we’ll get in touch with you!</Trans>
                  </div>
                </div>
              </div>

              {/* Question 12 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwelve">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwelve" aria-expanded="false" aria-controls="collapseTwelve">
                    <Trans>How can I become a vendor or sponsor?</Trans>
                  </button>
                </h2>
                <div id="collapseTwelve" className="accordion-collapse collapse" aria-labelledby="headingTwelve" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>We’d love to hear from you! Please contact us at</Trans> <a href="mailto:sponsor@amarefestival.com" className="text-primary">sponsor@amarefestival.com</a> <Trans>for vendor and sponsorship opportunities.</Trans>
                  </div>
                </div>
              </div>

              {/* Question 13 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingThirteen">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirteen" aria-expanded="false" aria-controls="collapseThirteen">
                    <Trans>Can I purchase tickets at the door?</Trans>
                  </button>
                </h2>
                <div id="collapseThirteen" className="accordion-collapse collapse" aria-labelledby="headingThirteen" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>It is highly recommended that you purchase tickets in advance through our official website, as tickets at the door are limited and may sell out quickly.</Trans>
                  </div>
                </div>
              </div>

              {/* Question 14 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFourteen">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFourteen" aria-expanded="false" aria-controls="collapseFourteen">
                    <Trans>Can I transfer my ticket to someone else?</Trans>
                  </button>
                </h2>
                <div id="collapseFourteen" className="accordion-collapse collapse" aria-labelledby="headingFourteen" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>Yes. We do not check the name on tickets for entry, so they can be transferred or resold. However, please note:</Trans>
                    <ul>
                        <li><Trans>We are not responsible for tickets purchased through third parties or aftermarket sales</Trans></li>
                        <li><Trans>We cannot assist with pricing disputes or guarantee the validity of resold tickets</Trans></li>
                    </ul>
                    <p class="notice"><Trans>For your protection, we recommend only purchasing tickets through our official channels.</Trans></p>
                  </div>
                </div>
              </div>

              {/* Question 15 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingFifteen">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFifteen" aria-expanded="false" aria-controls="collapseFifteen">
                    <Trans>Can I cancel my order or get a refund if I can no longer attend?</Trans>
                  </button>
                </h2>
                <div id="collapseFifteen" className="accordion-collapse collapse" aria-labelledby="headingFifteen" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <Trans>No. All sales are final - tickets are non-refundable and cannot be upgrades/downgrades, or canceled once purchased.</Trans>
                  </div>
                </div>
              </div>

              {/* Question 16 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSixteen">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixteen" aria-expanded="false" aria-controls="collapseSixteen">
                    <Trans>What happens if it rains?</Trans>
                  </button>
                </h2>
                <div id="collapseSixteen" className="accordion-collapse collapse" aria-labelledby="headingSixteen" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p><Trans>The event will proceed rain or shine. Please come prepared for the weather conditions.</Trans></p>
                    <p><Trans>In case of severe weather (such as thunderstorms) that could affect safety:</Trans></p>
                    <ul>
                      <li><Trans>We will notify all attendees via email</Trans></li>
                      <li><Trans>Updates will be posted on our website and social media</Trans></li>
                    </ul>
                    <p class="notice"><Trans>We recommend checking the forecast and bringing appropriate gear.</Trans></p>
                  </div>
                </div>
              </div>

              {/* Question 17 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingSeventeen">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventeen" aria-expanded="false" aria-controls="collapseSeventeen">
                    <Trans>Is parking available at the venue?</Trans>
                  </button>
                </h2>
                <div id="collapseSeventeen" className="accordion-collapse collapse" aria-labelledby="headingSeventeen" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p><Trans>Yes, on-site parking will be available.</Trans></p>
                    <p class="notice"><Trans>For the best experience, we recommend carpooling as spaces may be limited.</Trans></p>
                  </div>
                </div>
              </div>

              {/* Question 18 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingEighteen">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEighteen" aria-expanded="false" aria-controls="collapseEighteen">
                    <Trans>Can I leave and re-enter the venue?</Trans>
                  </button>
                </h2>
                <div id="collapseEighteen" className="accordion-collapse collapse" aria-labelledby="headingEighteen" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p><Trans>No re-entry is permitted. Once you exit the venue, you will not be allowed back in.</Trans></p>
                    <p class="notice"><Trans>This policy helps us maintain security and safety for all attendees.</Trans></p>
                  </div>
                </div>
              </div>

              {/* Question 19 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingNineteen">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseNineteen" aria-expanded="false" aria-controls="collapseNineteen">
                    <Trans>What payment methods are accepted at the venue?</Trans>
                  </button>
                </h2>
                <div id="collapseNineteen" className="accordion-collapse collapse" aria-labelledby="headingNineteen" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <p><Trans>We only accept the following payment methods:</Trans></p>
                    <ul>
                      <li><Trans>Credit cards (Visa, Mastercard)</Trans></li>
                      <li><Trans>Debit cards</Trans></li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Question 20 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwenty">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwenty" aria-expanded="false" aria-controls="collapseTwenty">
                    <Trans>What items are not allowed on the site?</Trans>
                  </button>
                </h2>
                <div id="collapseTwenty" className="accordion-collapse collapse" aria-labelledby="headingTwenty" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">

                    <div class="prohibited-category">
                      <h6><Trans>Weapons & Dangerous Items</Trans></h6>
                      <ul>
                        <li><Trans>Firearms, weapons, or sharp objects</Trans></li>
                        <li><Trans>Explosives, fireworks, or flammable items</Trans></li>
                        <li><Trans>Laser pointers</Trans></li>
                        <li><Trans>Compressed air horns</Trans></li>
                      </ul>
                    </div>

                    <div class="prohibited-category">
                      <h6><Trans>Substances</Trans></h6>
                      <ul>
                        <li><Trans>Illegal drugs or paraphernalia</Trans></li>
                        <li><Trans>Outside alcohol</Trans></li>
                        <li><Trans>Cigarette packs</Trans></li>
                      </ul>
                    </div>

                    <div class="prohibited-category">
                      <h6><Trans>Containers & Bags</Trans></h6>
                      <ul>
                        <li><Trans>Glass, metal, or hard plastic containers</Trans></li>
                        <li><Trans>Coolers or thermoses</Trans></li>
                        <li><Trans>Non-transparent bags larger than 7.5" x 5"</Trans></li>
                        <li><Trans>Large backpacks</Trans></li>
                      </ul>
                    </div>

                    <div class="prohibited-category">
                      <h6><Trans>Equipment</Trans></h6>
                      <ul>
                        <li><Trans>Professional cameras/video equipment</Trans></li>
                        <li><Trans>Recording devices</Trans></li>
                        <li><Trans>Musical instruments</Trans></li>
                        <li><Trans>Megaphones</Trans></li>
                      </ul>
                    </div>

                    <div class="prohibited-category">
                      <h6><Trans>Other Restricted Items</Trans></h6>
                      <ul>
                        <li><Trans>Pets (except service animals)</Trans></li>
                        <li><Trans>Bicycles, skateboards, roller skates</Trans></li>
                        <li><Trans>Drones or flying objects</Trans></li>
                        <li><Trans>Beach balls, sports equipment</Trans></li>
                        <li><Trans>Gang-related clothing</Trans></li>
                        <li><Trans>Umbrellas</Trans></li>
                        <li><Trans>Folding chairs</Trans></li>
                      </ul>
                    </div>

                    <p class="notice"><Trans>This list is not exhaustive. Security reserves the right to refuse any item deemed unsafe or disruptive. All bags and persons are subject to search.</Trans></p>
                  </div>
                </div>
              </div>

              {/* Question 21 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwentyOne">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyOne" aria-expanded="false" aria-controls="collapseTwentyOne">
                    <Trans>What items are allowed on the site?</Trans>
                  </button>
                </h2>
                <div id="collapseTwentyOne" className="accordion-collapse collapse" aria-labelledby="headingTwentyOne" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">

                    <div class="allowed-category">
                      <h6><Trans>Essentials</Trans></h6>
                      <ul>
                        <li><Trans>Empty plastic water bottles (max 32oz/1L)</Trans></li>
                        <li><Trans>Empty hydration packs (max 70oz/2L, no metal/glass components)</Trans></li>
                        <li><Trans>Small transparent bags (max 7.5" x 5")</Trans></li>
                        <li><Trans>Non-professional cameras (no detachable lenses)</Trans></li>
                      </ul>
                    </div>

                    <div class="allowed-category">
                      <h6><Trans>Personal Items</Trans></h6>
                      <ul>
                        <li><Trans>Mobile phones</Trans></li>
                        <li><Trans>Portable phone chargers</Trans></li>
                      </ul>
                    </div>

                    <div class="allowed-category">
                      <h6><Trans>Health & Accessibility</Trans></h6>
                      <ul>
                        <li><Trans>Prescription medication (in original container with prescription in your name)</Trans></li>
                        <li><Trans>Sunscreen (non-aerosol)</Trans></li>
                      </ul>
                    </div>

                    <div class="allowed-category">
                      <h6><Trans>Miscellaneous</Trans></h6>
                      <ul>
                        <li><Trans>Earplugs</Trans></li>
                        <li><Trans>Sunglasses</Trans></li>
                        <li><Trans>Hats</Trans></li>
                      </ul>
                    </div>

                    <p class="notice"><Trans>This list is not exhaustive. All items are subject to security inspection. When in doubt, check our prohibited items list or contact us beforehand.</Trans></p>
                  </div>
                </div>
              </div>


              {/* Question 22 */}
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwentyTwo">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwentyTwo" aria-expanded="false" aria-controls="collapseTwentyTwo">
                    <Trans>Additional general information</Trans>
                  </button>
                </h2>
                <div id="collapseTwentyTwo" className="accordion-collapse collapse" aria-labelledby="headingTwentyTwo" data-bs-parent="#faqAccordion">
                  <div className="accordion-body">
                    <div class="disclaimer">
                      <h6><Trans>Important Notice</Trans></h6>
                      <ul>
                        <li><Trans>Lineup changes: Artists and schedules are subject to change without notice.</Trans></li>
                        <li><Trans>Personal property: The festival is not responsible for lost, stolen, or damaged items.</Trans></li>
                        <li><Trans>Valuables: We strongly recommend leaving valuable items at home.</Trans></li>
                      </ul>
                      <p class="notice"><Trans>All purchases and attendance are subject to our</Trans> <a href="#terms"><Trans>Terms & Conditions</Trans></a>.</p>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;
